import React, { JSX, useState } from 'react';
import { SubscriptionInvoiceItem} from "../../../../../../types/entities";
import {Link, useGetManyReference} from "react-admin";
import {convertCurrencyToSymbol} from "../../../../../../defaults/defaults";
import { useStripeModeFetch } from "../../../../../global-hooks/default-system-hooks";
import {LinearProgress} from "@mui/material/esm";

export const ModalInvoiceItem: (props: any) => JSX.Element = (props: any): JSX.Element =>  {
    const invoiceItem: SubscriptionInvoiceItem = props.invoiceItem;
    let dateString: string;
    const date = new Date(invoiceItem.createdAt);
    let mVal: number = date.getMonth() + 1;
    let month: string = '';
    if (mVal < 10) {
        month = "0" + mVal;
    } else {
        month = mVal.toString();
    }
    let dVal: number = date.getDate();
    let day: string = '';
    if (dVal < 10) {
        day = "0" + dVal;
    } else {
        day = dVal.toString();
    }
    dateString = `${day}/${month}/${date.getFullYear()}`;

    return (
        <div className="items__block" >
            <div className="block__top">
                <span>{ invoiceItem.name }</span>
            </div>
            <div className="block__middle">
                <div className="middle__item">
                    <span className="item__title">{ "Amount" }</span>
                    <span>{ convertCurrencyToSymbol(invoiceItem?.currency) + parseFloat(invoiceItem?.amount)?.toFixed(2) }</span>
                </div>
                <div className="middle__item">
                    <span className="item__title">{ "Seats" }</span>
                    <span>{ invoiceItem?.quantity }</span>
                </div>
            </div>
            <div className="block__bottom">
                <span className="item__title">{ "Created:" }</span>
                <span>{ dateString }</span>
            </div>
        </div>
    );
}